module.exports = __webpack_public_path__ + "static/media/LogoCut.5ddc9ae5.png";